import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Big } from "big.js";
import { selectHashTotalBySaleLotIdLookup } from "selectors/saleLots/hashTotal";
import { formatNumber } from "lib";

export function SaleProgressHashTotal(): React.JSX.Element {
  const hashTotalBySaleLotIdookup = useSelector(
    selectHashTotalBySaleLotIdLookup,
  );

  const hashTotal = useMemo(
    () =>
      Object.values(hashTotalBySaleLotIdookup).reduce<Big>(
        (acc: Big, hash: Big) => acc.add(hash),
        new Big(0),
      ),
    [hashTotalBySaleLotIdookup],
  );

  return (
    <>
      <h3 title="A checksum of the sold lots, derived by summing the sold Sale Lot's unit prices">
        Hash Total
      </h3>
      <span>{formatNumber(hashTotal.toNumber(), 2, 2)}</span>
    </>
  );
}
